export default "__VITE_ASSET__8abf6b3b__"